(function () {
    "use strict";

    // @ngInject
    function OnboardingMobileQuizControllerCtor($scope, $injector, $timeout, AbTestService, Enums, $q, DeviceService, WorkspaceFileService,
                                                 _, OnboardingService, EventService, UsersManager, AnalyticsService, $translate, UserService, $state, UiPersistenceService, $stateParams, CompaniesManager, FacebookPixelTrackingService, CapterraService, CompanyService) {

        this.constructor.$super.call(this, $scope, $injector);
        this._objectType = 'OnboardingMobileQuizController';

        this.$scope = $scope;
        this._ = _;
        this.UserService = UserService;
        this.UsersManager = UsersManager;
        this.$state = $state;
        this.OnboardingService = OnboardingService;
        this.EventService = EventService;
        this.AnalyticsService = AnalyticsService;
        this.UiPersistenceService = UiPersistenceService;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.CompaniesManager = CompaniesManager;
        this.AbTestService = AbTestService;
        this.Enums = Enums;
        this.DeviceService = DeviceService;
        this.WorkspaceFileService = WorkspaceFileService;
        this.FacebookPixelTrackingService = FacebookPixelTrackingService;
        this.CapterraService = CapterraService;
        this.CompanyService = CompanyService;

        this.currUser = this.UsersManager.getCurrUser();
        this.company = this.CompaniesManager.getCurrCompany();
        this.isLoading = false;
        this.userTagData = {};
        this.isShowQuiz = false;
        this.smallLoading = false;

        var tagNamesInUse = {
            yearsInBusiness: 'Years_in_Business_Quiz',
            serviceGoodsOrBoth: 'Service_Goods_Or_Both_Quiz',
            whatNeedHelp: 'What_Do_You_Need_Help_With_Quiz',
            inquiriesPerMonth: 'Inquiries_Per_Month_Quiz',
            eventsPerMonth: 'Avg_Events_Jobs_Per_Month_Quiz',
            timeToBook: 'Time_To_Book_New_Lead_Quiz',
            avgRevenue: 'Avg_Annual_Revenue_Quiz',
            currentToolYouUse: 'Current_Tool_You_Use_Quiz'
        };

        var firstName = this.currUser.first_name;

        if (this.isQuizCompleted()) {
            this.goToOnboardingEntryPointState();
            return;
        }

        angular.element(document).find('body')[0].classList.add('onboarding-mobile-quiz-body-bg-white');
        $scope.$on("$destroy", function() {
            angular.element(document).find('body')[0].classList.remove('onboarding-mobile-quiz-body-bg-white');
        });

        var questions = {
            howLongInBusiness: function howLongInBusiness(quiz) {
                this.id = 'howLongInBusiness';
                this.title = $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_LONG_IN_BUSINESS._TEXT_', {first_name: firstName});
                this.userTagName = tagNamesInUse.yearsInBusiness;
                this.answers = [
                    {
                        id: 'notStarted',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_LONG_IN_BUSINESS.ANSWERS.NOT_STARTED._TITLE_'),
                        helper: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_LONG_IN_BUSINESS.ANSWERS.NOT_STARTED._HELPER_'),
                        feedback: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_LONG_IN_BUSINESS.ANSWERS.NOT_STARTED._FEEDBACK_')
                    },
                    {
                        id: 'new',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_LONG_IN_BUSINESS.ANSWERS.NEW._TITLE_'),
                        helper: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_LONG_IN_BUSINESS.ANSWERS.NEW._HELPER_'),
                        feedback: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_LONG_IN_BUSINESS.ANSWERS.NEW._FEEDBACK_')
                    },
                    {
                        id: '1to2',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_LONG_IN_BUSINESS.ANSWERS.ONE_TO_THREE._TITLE_'),
                        helper: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_LONG_IN_BUSINESS.ANSWERS.ONE_TO_THREE._HELPER_'),
                        feedback: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_LONG_IN_BUSINESS.ANSWERS.ONE_TO_THREE._FEEDBACK_')
                    },
                    {
                        id: '3to4',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_LONG_IN_BUSINESS.ANSWERS.FOUR_TO_FIVE._TITLE_'),
                        helper: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_LONG_IN_BUSINESS.ANSWERS.FOUR_TO_FIVE._HELPER_'),
                        feedback: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_LONG_IN_BUSINESS.ANSWERS.FOUR_TO_FIVE._FEEDBACK_')
                    },
                    {
                        id: '5plus',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_LONG_IN_BUSINESS.ANSWERS.SIX_PLUS._TITLE_'),
                        helper: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_LONG_IN_BUSINESS.ANSWERS.SIX_PLUS._HELPER_'),
                        feedback: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_LONG_IN_BUSINESS.ANSWERS.SIX_PLUS._FEEDBACK_')
                    }
                ];

                this.getNextQuestion = function getNextQuestion() {
                    return new questions.currentToolYouUse(quiz);
                };

                this.goNext = function goNext() {
                    quiz.nextIndex();
                    quiz.setQuestion(this.getNextQuestion());
                };

                this.getPreviousQuestion = function () {
                    return new questions.averageAnnualRevenue(quiz);

                };

                this.goBack = function goBack() {
                    quiz.previousIndex();
                    var _previousQuestion = this.getPreviousQuestion();
                    if (_previousQuestion) {
                        quiz.setQuestion(_previousQuestion);
                    }
                };
            },

            serviceGoodsOrBoth: function serviceGoodsOrBoth(quiz) {
                this.id = 'serviceGoodsOrBoth';
                this.title = $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.SERVICE_GOODS_OR_BOTH._TEXT_');
                this.userTagName = tagNamesInUse.serviceGoodsOrBoth;
                this.answers = [
                    {
                        id: 'service',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.SERVICE_GOODS_OR_BOTH.ANSWERS.SERVICE._TITLE_'),
                    },
                    {
                        id: 'sellingPhysicalOrDigital',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.SERVICE_GOODS_OR_BOTH.ANSWERS.GOODS._TITLE_'),
                    },
                    {
                        id: 'both',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.SERVICE_GOODS_OR_BOTH.ANSWERS.BOTH._TITLE_'),
                    }
                ];

                this.getNextQuestion = function getNextQuestion() {
                    return new questions.whatNeedHelp(quiz);
                };

                this.goNext = function goNext() {
                    quiz.nextIndex();
                    quiz.setQuestion(this.getNextQuestion());
                };

                this.getPreviousQuestion = function getPreviousQuestion() {
                    return new questions.howLongInBusiness(quiz);
                };

                this.goBack = function goBack() {
                    quiz.previousIndex();
                    quiz.setQuestion(this.getPreviousQuestion());
                };
            },

            whatNeedHelp: function whatNeedHelp(quiz) {
                this.id = 'whatNeedHelp';
                this.title = $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.WHAT_NEED_MOST._TEXT_');
                this.userTagName = tagNamesInUse.whatNeedHelp;
                this.answers = [
                    {
                        id: 'closingMoreInquiries',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.WHAT_NEED_MOST.ANSWERS.LEADS._TITLE_'),
                    },
                    {
                        id: 'closingMoreIdealClients',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.WHAT_NEED_MOST.ANSWERS.IDEAL._TITLE_'),
                    },
                    {
                        id: 'growingMyRevenue',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.WHAT_NEED_MOST.ANSWERS.REVENUE._TITLE_'),
                    },
                    {
                        id: 'automatingMyBookings',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.WHAT_NEED_MOST.ANSWERS.AUTOMATING._TITLE_'),
                    },
                    {
                        id: 'keepingTrack',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.WHAT_NEED_MOST.ANSWERS.ONE_PLACE._TITLE_'),
                    },
                    {
                        id: 'clientExperience',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.WHAT_NEED_MOST.ANSWERS.EXPERIENCE._TITLE_'),
                    },
                    {
                        id: 'bookingProcess',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.WHAT_NEED_MOST.ANSWERS.BOOKING._TITLE_'),
                    }
                ];

                this.getNextQuestion = function getNextQuestion() {
                    return new questions.averageAnnualRevenue(quiz);
                };

                this.goNext = function goNext() {
                    quiz.nextIndex();
                    quiz.setQuestion(this.getNextQuestion());
                };

                this.getPreviousQuestion = function () {
                    return new questions.howLongInBusiness(quiz);
                };

                this.goBack = function goBack() {
                    quiz.previousIndex();
                    quiz.setQuestion(this.getPreviousQuestion());
                };
            },

            inquiriesPerMonth: function inquiriesPerMonth(quiz) {
                this.id = "inquiriesPerMonth";
                this.title = $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_MANY_INQUIRIES._TEXT_');
                this.userTagName = tagNamesInUse.inquiriesPerMonth;
                this.answers = [
                    {
                        id: "0to5",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_MANY_INQUIRIES.ANSWERS.UP_TO_FIVE._TITLE_'),
                    },
                    {
                        id: "6to10",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_MANY_INQUIRIES.ANSWERS.SIX_TO_TEN._TITLE_'),
                    },
                    {
                        id: "11to20",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_MANY_INQUIRIES.ANSWERS.UP_TO_TWENTY._TITLE_'),
                    },
                    {
                        id: "21to50",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_MANY_INQUIRIES.ANSWERS.UP_TO_FIFTY._TITLE_'),
                    },
                    {
                        id: "51Plus",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_MANY_INQUIRIES.ANSWERS.FIFTY_PLUS._TITLE_'),
                    }
                ];

                this.getNextQuestion = function getNextQuestion() {
                    return new questions.eventsPerMonth(quiz);
                };

                this.goNext = function goNext() {
                    quiz.nextIndex();
                    quiz.setQuestion(this.getNextQuestion());
                };

                this.getPreviousQuestion = function getPreviousQuestion() {
                    return new questions.whatNeedHelp(quiz);
                };

                this.goBack = function goBack() {
                    quiz.previousIndex();
                    quiz.setQuestion(this.getPreviousQuestion());
                };
            },

            eventsPerMonth: function eventsPerMonth(quiz) {
                this.id = "eventsPerMonth";
                this.title = $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_MANY_PROJECTS._TEXT_');
                this.userTagName = tagNamesInUse.eventsPerMonth;
                this.answers = [
                    {
                        id: "0to1",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_MANY_PROJECTS.ANSWERS.ZERO_TO_ONE._TITLE_'),
                    },
                    {
                        id: "2to3",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_MANY_PROJECTS.ANSWERS.TWO_TO_THREE._TITLE_'),
                    },
                    {
                        id: "4to5",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_MANY_PROJECTS.ANSWERS.FOUR_TO_FIVE._TITLE_'),
                    },
                    {
                        id: "6to10",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_MANY_PROJECTS.ANSWERS.SIX_TO_TEN._TITLE_'),
                    },
                    {
                        id: "10Plus",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.HOW_MANY_PROJECTS.ANSWERS.TEN_PLUS._TITLE_'),
                    }
                ];

                this.getNextQuestion = function getNextQuestion() {
                    return new questions.timeToBook(quiz);
                };

                this.goNext = function goNext() {
                    quiz.nextIndex();
                    quiz.setQuestion(this.getNextQuestion());
                };

                this.getPreviousQuestion = function getPreviousQuestion() {
                    return new questions.whatNeedHelp(quiz);
                };

                this.goBack = function goBack() {
                    quiz.previousIndex();
                    quiz.setQuestion(this.getPreviousQuestion());
                };

            },

            timeToBook: function timeToBook(quiz) {
                this.id = "timeToBook";
                this.title = $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.TIME_TO_BOOK._TEXT_');
                this.userTagName = tagNamesInUse.timeToBook;
                this.answers = [
                    {
                        id: "lessThenADay",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.TIME_TO_BOOK.ANSWERS.LESS_THAN_DAY._TITLE_'),
                    },
                    {
                        id: "lessThenAWeek",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.TIME_TO_BOOK.ANSWERS.LESS_THEN_WEEK._TITLE_'),
                    },
                    {
                        id: "1to2Weeks",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.TIME_TO_BOOK.ANSWERS.ONE_TO_TWO_WEEKS._TITLE_'),
                    },
                    {
                        id: "3to4Weeks",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.TIME_TO_BOOK.ANSWERS.THREE_TO_FOUR_WEEKS._TITLE_'),
                    },
                    {
                        id: "monthPlus",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.TIME_TO_BOOK.ANSWERS.MONTH._TITLE_'),
                    }
                ];

                this.getNextQuestion = function getNextQuestion() {
                    return new questions.averageAnnualRevenue(quiz);
                };

                this.goNext = function goNext() {
                    quiz.nextIndex();
                    quiz.setQuestion(this.getNextQuestion());
                };

                this.getPreviousQuestion = function getPreviousQuestion() {
                    return new questions.eventsPerMonth(quiz);
                };

                this.goBack = function goBack() {
                    quiz.previousIndex();
                    quiz.setQuestion(this.getPreviousQuestion());
                };
            },

            averageAnnualRevenue: function averageAnnualRevenue(quiz) {
                this.id = "averageAnnualRevenue";
                this.title = $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.WHAT_AVERAGE_ANNUAL_REVENUE._TEXT_');
                this.userTagName = tagNamesInUse.avgRevenue;
                this.answers = [
                    {
                        id: "0-5k",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.WHAT_AVERAGE_ANNUAL_REVENUE.ANSWERS.LESS10K._TITLE_'),
                    },
                    {
                        id: "5k-20k",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.WHAT_AVERAGE_ANNUAL_REVENUE.ANSWERS.K5_TO_K20._TITLE_'),
                    },
                    {
                        id: "20k-50k",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.WHAT_AVERAGE_ANNUAL_REVENUE.ANSWERS.K20_TO_K50._TITLE_'),
                    },
                    {
                        id: "50k-200k",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.WHAT_AVERAGE_ANNUAL_REVENUE.ANSWERS.K50_TO_K200._TITLE_'),
                    },
                    {
                        id: "200k-plus",
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.WHAT_AVERAGE_ANNUAL_REVENUE.ANSWERS.MORE200K._TITLE_'),
                    }
                ];

                this.getNextQuestion = function getNextQuestion() {
                    return new questions.howLongInBusiness(quiz);
                };

                this.goNext = function goNext() {
                    quiz.nextIndex();
                    quiz.setQuestion(this.getNextQuestion());
                };


                this.getPreviousQuestion = function getPreviousQuestion() {
                    return new questions.whatNeedHelp(quiz);
                };

                this.goBack = function goBack() {
                    quiz.previousIndex();
                    quiz.setQuestion(this.getPreviousQuestion());
                };
            },

            currentToolYouUse: function currentToolYouUse(quiz) {
                this.id = 'currentToolYouUse';
                this.title = $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.CURRENT_TOOL_YOU_USE._TEXT_');
                this.userTagName = tagNamesInUse.currentToolYouUse;
                this.answers = [
                    {
                        id: 'anotherCrm',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.CURRENT_TOOL_YOU_USE.ANSWERS.ANOTHER_CRM._TITLE_')
                    },
                    {
                        id: 'accountingSoftware',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.CURRENT_TOOL_YOU_USE.ANSWERS.ACCOUNTING_SOFTWARE._TITLE_')
                    },
                    {
                        id: 'googleDocsEmail',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.CURRENT_TOOL_YOU_USE.ANSWERS.GOOGLE_DOCS_EMAIL._TITLE_')
                    },
                    {
                        id: 'schedulingSoftware',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.CURRENT_TOOL_YOU_USE.ANSWERS.SCHEDULING_SOFTWARE._TITLE_')
                    },
                    {
                        id: 'offlineMethods',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.CURRENT_TOOL_YOU_USE.ANSWERS.OFFLINE_METHODS._TITLE_')
                    },
                    {
                        id: 'other',
                        title: $translate.instant('ONBOARDING_MOBILE_QUIZ.QUESTIONS.CURRENT_TOOL_YOU_USE.ANSWERS.OTHER._TITLE_')
                    }
                ];

                this.getNextQuestion = function getNextQuestion() {
                    return new questions.lastQuestion();
                };

                this.goNext = function goNext() {
                    quiz.nextIndex();
                    quiz.setQuestion(this.getNextQuestion());
                };

                this.getPreviousQuestion = function getPreviousQuestion() {
                    return new questions.howLongInBusiness(quiz);
                };

                this.goBack = function goBack() {
                    quiz.previousIndex();
                    quiz.setQuestion(this.getPreviousQuestion());
                };
            },

            lastQuestion: function lastQuestion() {
                this.id = 'lastQuestion'
            }
        };

        var Quiz = function Quiz(options) {
            var currentQuestion = {};
            var answers;
            var currentIndex = 1;
            var length = options.length;

            this.start = function start(startQuestionKey) {
                currentIndex = 1;
                if (startQuestionKey) {
                    this.setQuestion(new questions[startQuestionKey](this))
                } else {
                    this.setQuestion(new questions.howLongInBusiness(this));
                }
                answers = {};
            };

            this.setQuestion = function setQuestion(question) {
                currentQuestion = question;
            };

            this.setQuestionById = function setQuestionById(questionId) {
                _.each(questions, function(question, key) {
                    if (key === questionId) {
                        this.setQuestion(new question(this));
                    }
                }.bind(this));
            };

            this.getCurrentQuestion = function getCurrentQuestion() {
                return currentQuestion;
            };

            this.setAnswer = function setAnswer(answer) {
                answers[currentQuestion.id] = answer;
            };

            this.getCurrentAnswer = function getCurrentAnswer() {
                return this.getAnswerByQuestionId(currentQuestion.id);
            };

            this.getAnswerByQuestionId = function getAnswerByQuestionId(questionId) {
                return answers[questionId];
            };

            this.nextIndex = function() {
                if (currentIndex <= length) {
                    currentIndex++;
                }
            };

            this.previousIndex = function() {
                if (currentIndex > 0) {
                    currentIndex--;
                }
            };

            this.getLength = function getLength() {
                return length;
            };

            this.getCurrentIndex = function getCurrentIndex() {
                return currentIndex;
            };

        };

        var quizOptions = {
            length: 4,
        };

        this.quiz = new Quiz(quizOptions);

        this.initQuiz = function initQuiz() {
            var startQuestionKey = 'whatNeedHelp';
            this.quiz.start(startQuestionKey);

            if ($stateParams.step && !!questions[$stateParams.step]) {
                this.quiz.setQuestionById($stateParams.step);
            }

            this.trackQuestionLoaded();

            this.$timeout(function() {
                this.isShowQuiz = true;
            }.bind(this), 500);
        };

        this.initQuiz();

    }

    Controllers.OnboardingMobileQuizController = Class(Controllers.BaseController, {
        constructor: OnboardingMobileQuizControllerCtor,

        isQuizCompleted: function isQuizCompleted() {
            var mobileQuizOnboardingCompleted = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.mobileQuizOnboardingCompleted, {});
            return mobileQuizOnboardingCompleted && mobileQuizOnboardingCompleted.completed;
        },

        trackQuestionLoaded: function trackQuestionLoaded() {
            var source = 'short';

            this.AnalyticsService.trackPageView(this, this.AnalyticsService.analytics_events.onboarding_mobile_quiz_load_panel, {
                source: source,
                initial_step: this.quiz.getCurrentQuestion().id
            });

            this.FacebookPixelTrackingService.trackCustom('QuizQuestionLoaded', {question: this.quiz.getCurrentQuestion().id});
        },

        handleClickAnswer: function handleClickAnswer(event, answer) {
            event.stopPropagation();
            event.preventDefault();

            var source = 'short';

            this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.onboarding_mobile_quiz_load_panel, {
                source: source,
                initial_step: this.quiz.getCurrentQuestion().id
            });

            this.FacebookPixelTrackingService.trackCustom('QuizQuestionAnswered', {question: this.quiz.getCurrentQuestion().id, answer: answer.id});
            if (this.quiz.getCurrentQuestion().id === 'averageAnnualRevenue' && this._.contains(['20k-50k', '50k-200k', '200k-plus'], answer.id)) {
                this.CapterraService.trackConversion();
            }

            answer.isLoading = true;
            this.quiz.setAnswer(answer.id);
            this.updateUserTagsObject(answer);

            this.$timeout(function() {

                answer.isLoading = false;
                this.nextStep();
            }.bind(this), 800);

        },

        updateUserTagsObject: function updateUserTags(answer) {
            var question = this.quiz.getCurrentQuestion();
            this.userTagData[question.userTagName] = answer.id;
        },



        handleClickSkip: function handleClickSkip() {
            this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.onboarding_mobile_quiz_skip,
                {
                    step: this.quiz.getCurrentQuestion().id
                }
            );

            this.FacebookPixelTrackingService.trackCustom('QuizQuestionSkipped', {question: this.quiz.getCurrentQuestion().id});

            this.nextStep();
        },

        handleClickBack: function handleClickBack() {
            this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.onboarding_mobile_quiz_back,
                {
                    step: this.quiz.getCurrentQuestion().id
                }
            );

            this.FacebookPixelTrackingService.trackCustom('QuizBackClicked', {question: this.quiz.getCurrentQuestion().id});

            this.previousStep();
        },

        nextStep: function nextStep() {
            var currentQuestion = this.quiz.getCurrentQuestion();
            currentQuestion.goNext();
            this.trackQuestionLoaded();
            var nextStep = this.quiz.getCurrentQuestion();
            //this controller serves two templates and states so this ensures we route to the correct one
            this.$state.go(this.$state.current.name, {step: nextStep.id}, {notify: false});
        },

        previousStep: function previousStep() {
            var currentQuestion = this.quiz.getCurrentQuestion();
            currentQuestion.goBack();
            var previousStep = this.quiz.getCurrentQuestion();
            this.$state.go(this.$state.current.name, {step: previousStep.id}, {notify: false});
        },

        isFinishedQuiz: function isFinishedQuiz() {
            return (this.quiz.getCurrentQuestion().id === "lastQuestion");
        },

        isFirstQuestion: function isFirstQuestion() {
            //  This should be changed upon change of logic
            return (this.quiz.getCurrentQuestion().id === "whatNeedHelp");
        },

        showSkip: function showSkip() {
            return !this.isFinishedQuiz();
        },

        showBack: function showBack() {
            return !this.isFirstQuestion() && !this.isFinishedQuiz();
        },

        showSteps: function showSteps() {
            return this.showBack();
        },

        handleClickDone: function handleClickDone() {
            this.OnboardingService.skipPreAppOnboarding();

            if (!this._.isEmpty(this.userTagData)) {
                this.UsersManager.addTagsToCurrUser(this.userTagData);

                this.FacebookPixelTrackingService.trackCustom('quiz', this.userTagData);
            }

            this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.onboarding_mobile_quiz_done);
            this.FacebookPixelTrackingService.trackCustom('QuizDone', {});
            this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.mobileQuizOnboardingCompleted, {completed: true});


            //***DO NOT DELETE***. we currently navigate contract users to the templates page. but in case we want to show the actual contract - this is the code we want to use.
            // handle landing from contracts landing page -
            // if ( this.OnboardingService.isAttributionLandingPageAgreement) {
            //     var agreement_file_id = this.currUser.onboarding_container.workspace_file_id;
            //     if (agreement_file_id) {
            //         this.goToState(this.AppStates.root_core_workspaceFile, {workspace_file_id: agreement_file_id});
            //     } else {
            //         this.$state.go(this.AppStates.root_core_navigation_templatesEditor, {templateModelKey: 'agreement'});
            //     }
            //} else
            if (!this.DeviceService.checkIfMobileSize()) {
                switch (this.quiz.getAnswerByQuestionId('lookPro')) {
                    case 'invoices':
                        this.$state.go(this.AppStates.root_core_onboardingInvoiceV2CreationStart);
                        break;
                    case 'contracts':
                        this.WorkspaceFileService.createFileWithProject('agreement', undefined, undefined,
                            this.EventService.createDefaultProject(this.company).dataOnly())
                            .then(function success(resp) {
                                // success block
                            }.bind(this)).catch(function error(e) {
                            this.$state.go(this.AppStates.root_core_navigation_templatesEditor,
                                {templateModelKey: 'agreement'});
                        }.bind(this));
                        break;
                    default:
                        this.goToOnboardingEntryPointState();
                }
            } else {
                this.goToOnboardingEntryPointState();
            }

        },

        goToOnboardingEntryPointState: function goToOnboardingEntryPointState() {
            var params = {};
            var nextRoute = this.OnboardingService.getOnboardingEntryPointState();
            if (nextRoute === this.AppStates.root_core_onboardingInvoiceV2CreationStart) {
                params.source = 'signup';
            }
            this.$state.go(nextRoute, params);
        },

        getAnswerFeedback: function getAnswerFeedback() {
            if(angular.isFunction(this.quiz.getCurrentQuestion().getPreviousQuestion)) {
                var prevQuestion = this.quiz.getCurrentQuestion().getPreviousQuestion();

                // find the answer selected for the previous question
                var prevAnswerId = this.quiz.getAnswerByQuestionId(prevQuestion.id);
                var prevAnswer = this._.detect(prevQuestion.answers, function(answer) {
                    return answer.id === prevAnswerId;
                });

                if(prevAnswer) {
                    return prevAnswer.feedback;
                }
            }
        }
    });
}());
